import React, { Component } from 'react';

class About extends Component {
  render() {
    return (
      <div>
      <p> What we're all about </p>
      </div>
    );
  }
}

export default About;



/** WEBPACK FOOTER **
 ** ./src/components/About.js
 **/